import { EllipsisIcon, PanelBottomIcon, PanelRightIcon } from "lucide-react";
import { Menu, MenuTrigger, MenuPopup, MenuItem } from "../ui/menu";

export function UnavailableHeaderActions({ reason }: { readonly reason: string }) {
  return (
    <div className="sm:hidden">
      <Menu>
        <MenuTrigger
          aria-label="Panel actions"
          className="flex size-touch items-center justify-center rounded-(--control-radius) text-muted-foreground hover:bg-muted/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          <EllipsisIcon aria-hidden="true" className="size-4" />
        </MenuTrigger>
        <MenuPopup align="end" className="max-w-64">
          <p className="px-2 py-2 text-sm text-muted-foreground">{reason}</p>
          <MenuItem disabled className="min-h-touch">
            <PanelBottomIcon />
            Terminal
          </MenuItem>
          <MenuItem disabled className="min-h-touch">
            <PanelRightIcon />
            Right sidebar
          </MenuItem>
        </MenuPopup>
      </Menu>
    </div>
  );
}
